import {Component, ElementRef, Inject, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AlertService} from 'ngx-alerts';
import {DashboardService} from '../../../services/dashboard.service';
import {NgxSpinnerService} from 'ngx-spinner';
import {PageEvent} from '@angular/material/paginator';
import {finalize} from 'rxjs/operators';
import {split} from 'ts-node';
import {DRIVING_SCHOOL_MENU} from '../../../layouts/shared/sidebar/driving.school.menu';
import {MENU} from '../../../layouts/shared/sidebar/menu';
import {LOCAL_STORAGE, StorageService} from 'ngx-webstorage-service';
import {DaterangepickerDirective} from 'ngx-daterangepicker-material';

@Component({
  selector: 'app-trips',
  templateUrl: './trips.component.html',
  styleUrls: ['./trips.component.scss']
})
export class TripsComponent implements OnInit {
  userTrips: any[] = [];
  customerName: string = '';
  customerId: any;
  search = {
    size: 10,
    page: 0,
    isFleetView: false,
    periodFrom: '',
    periodTo: ''
  };

  totalRecords = 0;
  pageEvent: PageEvent;
  vehicleId: any;
  vehicleName = '';
  userType = '';
  public selected: { startDate: any, endDate: any };
  @ViewChild(DaterangepickerDirective, {static: false}) pickerDirective: DaterangepickerDirective;
  @ViewChild('dateRangePicker') dateRangePicker: ElementRef;

  constructor(private router: Router, private route: ActivatedRoute, private alertService: AlertService,
              public dashboardService: DashboardService, private spinner: NgxSpinnerService,
              @Inject(LOCAL_STORAGE) private storage: StorageService,) {
    this.userType = this.storage.get('gs-loggedInUserType');
    this.userType = this.userType.toLowerCase();
    if (this.userType == 'fleet') {
      this.search.isFleetView = true;
    }


  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(
      (res: any) => {
        this.customerName = res['customerName'];
        this.vehicleName = res['vehicleName'];
        this.vehicleId = res.vehicleId;
      }
    );
    let userType = this.storage.get('gs-loggedInUserType');
    if (userType && userType.toLowerCase() == 'drivingschool') {
      this.search['isTrainingData'] = true;
    }
    this.route.params.subscribe(
      (res: any) => {
        if (this.vehicleId) {
          this.getTripsByVehicle();
        } else {
          this.customerId = res['id'];
          this.getTrips();
        }
      }
    );
  }

  private getTrips() {
    this.spinner.show();
    this.dashboardService.getUserTrips(this.customerId, this.search).pipe(finalize(() => this.spinner.hide())).subscribe(
      (res: any) => {
        this.totalRecords = res.totalRecords;
        this.userTrips = res.userTrips;
      }, error1 => {
        console.error(error1);
        this.alertService.danger(error1.message ? error1.message : error1);
      }
    );
  }

  getServerData(ev: PageEvent) {
    this.search.page = ev.pageIndex;
    this.search.size = ev.pageSize;
    if (this.vehicleId) {
      this.getTripsByVehicle();
    } else {
      this.getTrips();
    }
    return ev;
  }

  processLocationName(startLocationName: any) {
    return startLocationName ? startLocationName.split(',').slice(0, 4) : '-';
  }

  private getTripsByVehicle() {
    this.spinner.show();
    this.dashboardService.getUserTripsByVehicle(this.vehicleId, this.search).pipe(finalize(() => this.spinner.hide())).subscribe(
      (res: any) => {
        this.totalRecords = res.totalRecords;
        this.userTrips = res.userTrips;
      }, error1 => {
        console.error(error1);
        this.alertService.danger(error1.message ? error1.message : error1);
      }
    );
  }

  getDuration(time: number) {
    if (time > 60) {
      return Math.floor(time / 60) + 'H ' + (time % 60) + 'min';
    } else {
      return time + 'min';
    }
  }

  onDatesChanged(ev) {
    ev = JSON.parse(JSON.stringify(ev));
    if (ev.startDate && ev.endDate) {
      this.search.periodFrom = ev.startDate.split('T')[0];
      this.search.periodTo = ev.endDate.split('T')[0];
      this.getTrips();
    }
  }

  onDateRangeModelChange(ev: any) {
    let d = JSON.parse(JSON.stringify(ev));
    if (d.start==undefined) {
      this.search.periodFrom = null;
      this.search.periodTo = null;
      this.getTrips();
    }
  }

}
